import { defineMessages } from 'react-intl';

/* eslint-disable perfectionist/sort-object-types */
export const messages: {
	viewAllAppsLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	/* eslint-enable perfectionist/sort-object-types */
} = defineMessages({
	viewAllAppsLabel: {
		id: 'navigation.global-shortcuts.view-all-apps.label',
		description: 'Button in Global App Shortcuts linking to a page to view all available apps',
		defaultMessage: 'View all apps',
	},
});
